import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_DELIVERY_CHARGES_SLABS_REQUEST,
  UPDATE_DELIVERY_CHARGES_SLABS_REQUEST,
} from "./actionTypes";
import {
  getDeliveryChargesSlabsResponse,
  updateDeliveryChargesSlabsResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getDeliveryChargesSlabs() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/SiteSetting/GetDlvryChrgsSlabs",
      ""
    );
    yield put(getDeliveryChargesSlabsResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateDeliveryChargesSlabs({ payload: { data } }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/SiteSetting/UpdateDlvryChrgsSlabs",
      data
    );
    yield put(updateDeliveryChargesSlabsResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchSiteSetting() {
  yield takeEvery(GET_DELIVERY_CHARGES_SLABS_REQUEST, getDeliveryChargesSlabs);
  yield takeEvery(
    UPDATE_DELIVERY_CHARGES_SLABS_REQUEST,
    updateDeliveryChargesSlabs
  );
}

function* siteSettingSaga() {
  yield all([fork(watchSiteSetting)]);
}

export default siteSettingSaga;
